import styled from "styled-components";

export const StyledSocials = styled.div`
  ul {
    display: inline-flex;
    list-style: none;
    li {
        padding-inline: 10px;
        a {
            text-decoration: none;
            color: var(--white);
            &:hover {
              color: var(--purple);
            }
        }
    }
  }
`